import {
  chainValidations,
  makeFormStateWithModel,
  validateMinLength,
} from 'formtastisch'
import { type IntlShape } from 'react-intl'

import { validateRequired } from '../base-form-handling'

export const OTP_LENGTH = 6

export const makeLoginRegistrationOneTimePasswordInputFormState = (
  intl: IntlShape,
  email: string,
  password: string,
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/explicit-module-boundary-types -- the rule was disabled before a comment became required
) => {
  return makeFormStateWithModel({
    initialData: {
      fcSolution: '',
      password,
      username: email,
    },
    validations: {
      password: (value: string) => {
        return chainValidations(
          () =>
            validateRequired(
              value,
              intl.formatMessage({ id: 'form.error.input.missing' }),
            ),
          () => {
            const passwordWithoutSpace = value.replace(' ', '')

            return validateMinLength(
              passwordWithoutSpace,
              OTP_LENGTH,
              intl.formatMessage(
                { id: 'form.error.input.minLength' },
                { minLength: OTP_LENGTH },
              ),
            )
          },
        )
      },
    },
  })
}

export type LoginRegistrationOneTimePasswordInputFormState = ReturnType<
  typeof makeLoginRegistrationOneTimePasswordInputFormState
>
